import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../assets/styles/GlobalStyles';
import { FaExclamationTriangle, FaRedo } from 'react-icons/fa';

const ErrorContainer = styled.div`
  text-align: center;
  padding: 48px 24px;
  background: ${colors.white};
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
`;

const ErrorIcon = styled.div`
  font-size: 48px;
  color: ${colors.red};
  margin-bottom: 16px;
`;

const ErrorTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a2c3e;
  margin-bottom: 8px;
`;

const ErrorMessage = styled.p`
  color: #5a6e7c;
  margin-bottom: 24px;
`;

const RetryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: ${colors.darkBlue};
  color: ${colors.white};
  border: none;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${colors.lightBlue};
    transform: translateY(-2px);
  }
`;

const RequestsError = ({ error, onRetry }) => {
  return (
    <ErrorContainer>
      <ErrorIcon>
        <FaExclamationTriangle />
      </ErrorIcon>

      <ErrorTitle>Erro ao carregar solicitações</ErrorTitle>

      <ErrorMessage>
        {error || 'Não foi possível carregar suas solicitações. Tente novamente.'}
      </ErrorMessage>

      <RetryButton onClick={onRetry}>
        <FaRedo /> Tentar Novamente
      </RetryButton>
    </ErrorContainer>
  );
};

export default RequestsError;
